import React, { useState,useEffect,useContext } from 'react';
import { Form, Button, Row, Col, Container } from 'react-bootstrap';
import '../css/AuthForm.css'; // Import your custom CSS file
import { RecaptchaVerifier, signInWithPhoneNumber, PhoneAuthProvider,getAuth } from 'firebase/auth';
import { auth,db } from '../FireBase'; // Ensure this is correctly imported
import ToastNotification from '../components/ToastAlert';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { AuthContext } from '../context/AuthContext'; // Import the AuthContext
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css"; // Bootstrap styling
import OTPInput from "react-otp-input"; // Import OTP input library
import { useNavigate } from "react-router-dom";
// import { requestForToken } from "../firebase-messaging-sw"; // Import token function



// Styling for better alignment
const styles = {
  container: {
    width: "300px",
    margin: "auto",
    textAlign: "center",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    alignItems: "center",
  },
  input: {
    width: "100%",
    height: "40px",
  },
  otpInput: {
    width: "40px",
    height: "40px",
    margin: "5px",
    textAlign: "center",
    fontSize: "20px",
    border: "1px solid #ccc",
    borderRadius: "5px",
  },
  button: {
    marginTop: "10px",
    padding: "8px 15px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

const PhoneAuth = () => {
  const defaultCountryCode = '+'; // Set your default country code here
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [verificationId, setVerificationId] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('');
  const [loading, setLoading] = useState(false); // To indicate loading state
  const [confirmationResult, setConfirmationResult] = useState(null); // To store confirmation result
  const [otpSent, setOtpSent] = useState(false); // To indicate if OTP has been sent
  const { checkUserAndSet } =useContext(AuthContext); // Use the AuthContext
  const navigate = useNavigate();
  useEffect(() => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            console.log("reCAPTCHA verified!", response);
          },
        }
      );
    }
  }, []);
  
  // useEffect(() => {
  //   setUpRecaptcha();
  // }, []);


  
  // const setUpRecaptcha = () => {

  //   window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
  //       'size': 'invisible',
  //       'callback': (response) => {
  //         // reCAPTCHA solved, allow signInWithPhoneNumber.
  //         console.log("reCAPTCHA verified!", response);
  //       }
  //     });
  // };

  const handleSendOtp = async (e) => {
    e.preventDefault();
  
    if (loading) return; // ⛔ prevent multiple clicks
    setLoading(true);
  
    const fullPhoneNumber = defaultCountryCode + phoneNumber;
    const appVerifier = window.recaptchaVerifier;
  
    try {
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        fullPhoneNumber,
        appVerifier
      );
      setConfirmationResult(confirmationResult);
      setVerificationId(confirmationResult.verificationId);
      setOtpSent(true);
  
      setToastMessage("OTP sent!");
      setToastVariant("success");
      setShowToast(true);
      setError("");
    } catch (error) {
      console.error("Error during signInWithPhoneNumber", error);
      setToastMessage("Failed to send OTP. Please try again.");
      setToastVariant("danger");
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };
  
  

const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!confirmationResult) {
      setToastMessage('Please request OTP first.');
      setToastVariant('warning');
      setShowToast(true);
      return;
    }
    setLoading(true);
    try {
      const result = await confirmationResult.confirm(otp);
      const user = result.user;
      console.log(user)
      try {
        await checkUserAndSet(user.phoneNumber,navigate);
        setToastMessage('Logged in successfully!');
        setShowToast(true);
        // localStorage.setItem("userdetails", user);
        

        
        const userDetails = JSON.stringify( user.phoneNumber );
        window.localStorage.setItem('userdetails', userDetails);
        
        // Notify React Native immediately:
        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          window.ReactNativeWebView.postMessage(userDetails);
        }
      

        // console.log(localStorage.getItem("userdetails"));
      } catch (error) {
        console.log(error);
      }

      setToastVariant('success');
      setShowToast(true);

      // if (userDoc.exists()) {
      //   // User exists, log in
      //   await checkUserAndSet(user.phoneNumber);

      //   setToastMessage('Logged in successfully!');
      //   setToastVariant('success');
      //   setShowToast(true);

      // } else {
      //   // New user, create user document
      //   await registerUserAndSet(user.phoneNumber);
       
      //   setToastMessage('Account created successfully!');
      //   setToastVariant('success');
      //   setShowToast(true);
      // }
    
    } catch (error) {
      console.error('Error during confirmationResult.confirm', error);
      setToastMessage('Failed to verify OTP. Please try again.');
      setToastVariant('danger');
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = () => {
    window.location.reload();
  };


  
  return (
  
    <div className="auth-bg ">
     <ToastNotification
        show={showToast}
        onClose={() => setShowToast(false)}
        message={toastMessage}
        variant="success"
      />
      <Container className="padding-con justify-content-center align-items-center auth-container">
        <Row className="justify-content-center">
          <Col>
            <div className="text-center mb-4">
              <h1 style={{color:'#1c5f8b'}}>
              {/* <span className='satisfy-regular'>
                Natural Delight
              </span> */}
              <img  src='Logo.png' alt="Kabli holidays" style={{width:'200px'}}/>
              </h1>
              <h5 style={{color:'#1c5f8b'}}>Sign in</h5>
            </div>

            {!otpSent && (
              <Form onSubmit={handleSendOtp}>
                <Form.Group controlId="formPhone" className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                
                   <PhoneInput
                      country={"in"} // India default
                      onlyCountries={["in"]} // Only allow India
                      disableDropdown={true} // Disable country selection
                      value={phoneNumber}
                      onChange={(value) => setPhoneNumber(value)}
                      inputStyle={{
                        width: "100%", 
                        height: "40px"
                      }}
                />
                </Form.Group>
                <Button
                  
                  type="submit"
                  className="w-100 mt-4 btn-own"
                  disabled={loading}
                >
                  {loading ? 'Sending OTP...' : 'Send OTP'}
                </Button>
              </Form>
            )}

            {otpSent && (
              <>
                <p style={{textAlign:'center'}}>OTP sent to {defaultCountryCode + phoneNumber}</p>
                <Form onSubmit={handleVerifyOtp} className="mt-4">
                  <Form.Group controlId="formOtp" className="mb-3">
                   <div style={{ display: 'flex', justifyContent: 'center' }}>
                 
                       <OTPInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={6} // 6-digit OTP
                        shouldAutoFocus={true}
                        inputType="tel" // Allows only numbers
                        renderInput={(props) => <input {...props} style={styles.otpInput} />}
                      />
                      </div>
                  </Form.Group>
                  <Button
                    
                    type="submit"
                    className="w-100 mt-4 btn-own"
                    disabled={loading}
                  >
                    {loading ? 'Verifying OTP...' : 'Verify OTP'}
                  </Button>
                </Form>
                <Button
                  variant="link"
                  className="w-100 mt-2"
                  onClick={handleResendOtp}
                  style={{textDecoration:'none'}}
                >
                  Resend OTP
                </Button>
              </>
            )}
            <div id="recaptcha-container"></div>
          </Col>
        </Row>
      </Container>
    </div>
   
  );
};

export default PhoneAuth;